import * as React from "react";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import { Box, IconButton, Popover, Paper } from "@mui/material";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import classes from "./TableComponent.module.css";
import MenuItem from "@mui/material/MenuItem";

export const ManageColumnComponents = ({
  columns,
  selectedColumns,
  onColumnChange,
}) => {
  const [columnList, setColumnList] = React.useState(columns);
  const [draggedItem, setDraggedItem] = React.useState("");
  const [opened, setOpened] = React.useState(null);

  // this is main function to column change
  const handleColumnChange = (column) => {
    const updatedSelectedColumns = selectedColumns.includes(column)
      ? selectedColumns.filter((col) => col.headerName !== column.headerName)
      : [...selectedColumns, column];
    onColumnChange(updatedSelectedColumns);
  };

  // Drag and drop functionality
  const handleDragStart = (index) => {
    setDraggedItem(index);
  };

  const handleDrop = (index) => {
    const updatedColumnList = [...columnList];
    const [removedItem] = updatedColumnList.splice(draggedItem, 1);
    updatedColumnList.splice(index, 0, removedItem);

    // Update the IDs of the columns
    updatedColumnList.forEach((column, index) => {
      column.id = index + 1;
    });

    setColumnList(updatedColumnList);

    // get the columns array by index value
    const droppedColumn = updatedColumnList[index];
    const updatedSelectedColumns = selectedColumns.filter(
      (col) => col.headerName !== droppedColumn.headerName
    );
    onColumnChange(updatedSelectedColumns);
  };

  // Handle opening and closing of the Popover
  const handleClick = (event) => {
    setOpened(event.currentTarget);
  };

  const handleClose = () => {
    setOpened(null);
  };

  const open = Boolean(opened);

  return (
    <Box
      variant="outlined"
      sx={{
        marginTop: "10px",
        display: "flex",
        justifyContent: "end",
      }}
    >
      <IconButton className={classes.manageColumnIcon} onClick={handleClick}>
        <ViewColumnIcon sx={{ fontSize: "40px" }} />
      </IconButton>
      <Popover
        sx={{ marginTop: "45px" }}
        open={open}
        anchorEl={opened}
        onClose={handleClose}
      >
        <Paper>
          {columnList.map((column, index) => (
            <MenuItem
              sx={{ width: "300px" }}
              key={column.headerName}
              value={column}
              draggable
              onDragStart={() => handleDragStart(index)}
              onDragOver={(e) => e.preventDefault()}
              onDrop={() => handleDrop(index)}
              onClick={() => handleColumnChange(column)}
            >
              <Checkbox
                checked={selectedColumns.some(
                  (col) => col.headerName === column.headerName
                )}
              />
              <ListItemText primary={column.headerName} />
            </MenuItem>
          ))}
        </Paper>
      </Popover>
    </Box>
  );
};

// import { Menu, Checkbox } from 'antd';
// import './CustomMenu.css'; // Import your custom CSS file

// {columnList.map((column, index) => (
//   <Menu style={{ width: "300px" }}>
//     <Menu.Item
//       key={column.headerName}
//       draggable
//       className="custom-menu-item" // Add custom class
//       onDragStart={() => handleDragStart(index)}
//       onDragOver={(e) => e.preventDefault()}
//       onDrop={() => handleDrop(index)}
//       onClick={() => handleColumnChange(column)}
//     >
//       <Checkbox checked={selectedColumns.some((col) => col.headerName === column.headerName)} />
//       {column.headerName}
//     </Menu.Item>
//   </Menu>
// ))}